import { render, staticRenderFns } from "./AttachmentCountRenderer.vue?vue&type=template&id=54dae8d8&"
import script from "./AttachmentCountRenderer.vue?vue&type=script&lang=js&"
export * from "./AttachmentCountRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports